<script>
	import Presentaciones from './presentaciones.svelte'
	import {acListCheck, getLoggedUser} from '../global.js'
</script>



{#if acListCheck('VER-PRESENTACIONES')}
	<Presentaciones />
{:else}
	<p>No tiene permiso para VER-PRESENTACIONES.</p>
{/if}